// Page-scoped inspector hook: holds the currently selected entity and renders
// the drawer on-demand via React state.

import { useCallback, useState } from 'react';

export function useInspector(initial = null) {
  const [target, setTarget] = useState(initial);
  const open = useCallback((entity) => setTarget(entity), []);
  const close = useCallback(() => setTarget(null), []);
  return { target, open, close, isOpen: target != null };
}
